/// baseUrl 들어가는 곳

// export const fcmUrl = 'http://misnetwork.iptime.org:3989/api'; // fcm 서버
export const fcmUrl = "/fcm";

// export const baseUrl = 'http://misnetwork.iptime.org:4989/api';
export const baseUrl = "/api"; // https에서 http 요청은 보안 위협으로 간주 돼 iis에서 프록시 설정 후 변경된 주소
